import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const ChildrenCompletingDailyWorksheets = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Children completing daily worksheets (%)" />
    </Box>
  );
};
